export const PRODUCT_NAME = "Database Entry System";
